var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 d-flex h-100 w-100"},[_c('received-files-sidebar'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column h-100 w-100"},[_c('received-files-header'),_vm._v(" "),_c('transition',{attrs:{"name":"slideup","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c89f64","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/received-files-view/received-files-inbox.vue
// module id = 107
// module chunks = 0